/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ListAnalysesOverviewSortBy = (typeof ListAnalysesOverviewSortBy)[keyof typeof ListAnalysesOverviewSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListAnalysesOverviewSortBy = {
  name: "name",
  state: "state",
  created_at: "created_at",
  updated_at: "updated_at",
} as const;
